import { H1 } from '@berlitz/globals'
import styled from 'styled-components'

import { HeaderProps } from './interface'

export const Header = styled.div<HeaderProps>`
  display: flex;
  flex-direction: row;
  align-items: center;

  // @ts-ignore
  ${H1} {
    vertical-align: middle;
    margin: 0;
    // @ts-ignore
    // margin-left: ${({ theme }) => theme.space.md};
  }
`

export const MainNav = styled.div`
  margin-top: ${({ theme }) => theme.space.md};
`

export const SubNav = styled.div`
  margin-bottom: ${({ theme }) => theme.space.lg};
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    overflow-x: scroll;

    ul {
      width: max-content;
    }
  }
`

export const Wrapper = styled.div`
  padding-right: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding-right: ${({ theme }) => theme.space.lg};
  }

  .avatar {
    background-color: ${({ theme }) => theme.palette.red100};
    border-color: ${({ theme }) => theme.palette.gray100};

    span {
      svg {
        color: ${({ theme }) => theme.colors.brandPrimaryContrast};
        font-size: ${({ theme }) => theme.fontSize.lg};
      }
    }
  }
`

export const CertWrapper = styled.div`
  border-radius: 2px;
  ${({ theme }) => `
    border: 1px solid ${theme.palette.gray100};
  `}

  ul {
    list-style: disc;
  }
`

export const CertPanel = styled.div`
  ${({ theme }) => `
    padding: ${theme.space.md} ${theme.space.lg} ${theme.space.lg} ${theme.space.lg};
  `}
`

export const CertShareLabel = styled.div`
  ${({ theme }) => `
    font-weight: ${theme.fontWeight.bold};
    font-size: ${theme.fontSize.xxs};
  `}
`

export const CertShareLink = styled.a`
  ${({ theme }) => `
    font-weight: ${theme.fontWeight.bold};
    font-size: ${theme.fontSize.xs};
  `}
`
